import React, { useState, useEffect } from "react";
import Uploder from "../Uploader";
import { Button, DatePickerComp, Input, Select } from "../Form";
import { BiChevronDown } from "react-icons/bi";
import { toast } from "react-hot-toast";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import ProcessingBar from "../ProcessingBar/ProcessingBar";
import ProcessingBar2 from "../ProcessingBar/ProcessingBar2";
import sericesApi from "../../api/user/service.api";
import TimeSlotSelector from "../TimeSlot";
import { MultiSelect } from "../MultiSelect";
import Loading from "../../Util/Loading";
import { useDispatch, useSelector } from "react-redux";
import userApi from "../../api/user/user.api";
import { setUser } from "../../redux/features/userSlice";

function OperatorInfo() {
  //send operator Id
  const { user } = useSelector((state) => state.user);

  console.log({ user });

  const navigate = useNavigate();
  const [Images, setImages] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const dispatch = useDispatch();

  const createStaffForm = useFormik({
    initialValues: {
      email: user?.email,
      name: user?.name,
      phone: user?.phone,
      town: user?.town,
      address: user?.address,
      photo: user?.photo,
      operator: user?._id,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format") // Ensures proper email format
        .min(3, "Email must be at least 3 characters")
        .required("Required"),
      name: Yup.string()
        .min(3, "Display name must be at least 3 characters")
        .required("Required"),
      phone: Yup.string()
        .min(3, "Phone must be at least 3 characters")
        .required("Required"),
      address: Yup.string()
        .min(3, "address must be at least 3 characters")
        .required("Required"),
      town: Yup.string()
        .min(3, "town must be at least 3 characters") // Fix incorrect error message
        .required("Required"),
      photo: Yup.string()
        .min(3, "Photo must be at least 3 characters")
        .required("Required"),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      console.log("Form values with photo:", values);
      try {
        const response = await userApi.updateProfile(values);

        setIsUploading(true);
        console.log({ response });
        if (response) {
          // createStaffForm.resetForm();
          dispatch(setUser(response.updatedOperator));
          setIsUploading(false);
          toast.success("Update Profile successfully");
        }
      } catch (error) {
        console.error(error);
        setErrorMessage(error.message);
        toast.error(error.message);
      }
    },
  });

  useEffect(() => {
    console.log("Validation errors:", createStaffForm.errors);
  }, [createStaffForm.errors]);

  const updateImages = (newImageUrl) => {
    setImages([newImageUrl]);
    createStaffForm.setFieldValue("photo", newImageUrl || "");
  };

  if (isLoading) return <Loading />;

  return (
    <form
      onSubmit={createStaffForm.handleSubmit}
      className="space-y-4 z-[1000]"
    >
      <input
        type="text"
        name="name"
        placeholder="Enter Name"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-neutral-500 text-white rounded-lg focus:border focus:border-subMain"
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        value={createStaffForm.values.name}
      />
      {createStaffForm.errors.email && createStaffForm.touched.name && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.name}</p>
      )}
      <input
        type="text"
        name="email"
        placeholder="Enter Email"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-neutral-500 text-white rounded-lg focus:border focus:border-subMain"
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        value={createStaffForm.values.email}
      />
      {createStaffForm.errors.email && createStaffForm.touched.email && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.email}</p>
      )}
      <input
        type="text"
        name="phone"
        placeholder="Phone Number"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-neutral-500 text-white rounded-lg focus:border focus:border-subMain"
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        value={createStaffForm.values.phone}
      />
      {createStaffForm.errors.email && createStaffForm.touched.phone && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.phone}</p>
      )}
      <input
        type="text"
        name="address"
        placeholder="Address"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-neutral-500 text-white rounded-lg focus:border focus:border-subMain"
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        value={createStaffForm.values.address}
      />
      {createStaffForm.errors.address && createStaffForm.touched.address && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.address}</p>
      )}
      <input
        type="text"
        name="town"
        placeholder="Town"
        className="w-full bg-transparent text-sm mt-3 p-4 border border-neutral-500 text-white rounded-lg focus:border focus:border-subMain"
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        value={createStaffForm.values.town}
      />
      {createStaffForm.errors.town && createStaffForm.touched.town && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.town}</p>
      )}

      <div className="flex gap-3 flex-col w-full col-span-6">
        <p className="text-sm text-text">Profile Image</p>
        <Uploder refreshFunction={updateImages} previewImage={user?.photo} />
      </div>
      {createStaffForm.errors.photo && createStaffForm.touched.photo && (
        <p className="text-red-500 text-xs">{createStaffForm.errors.photo}</p>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-1 gap-4 w-full">
        <Button
          type="submit" // This now correctly submits the form
          label="Update"
          loading={isUploading}
          Icon={HiOutlineCheckCircle}
          onClick={() => console.log("🟢 Button clicked")} // optional debug
        />
      </div>
    </form>
  );
}

export default OperatorInfo;
